import { useSelector } from "react-redux";
import { WorkspaceItem } from "src/types/experiences/workspaces";

interface ExperiencesWorkspaceState {
  experiences: {
    workspaces: {
      workspace: {
        item: WorkspaceItem | null;
      };
    };
  };
}

/**
 * Whether the active workspace user is allowed to create storyboards.
 *
 * Driven by the workspace-level `workspaceManagement.createStoryBoards` flag on
 * the user's role(s); superAdmins always pass. While the workspace is still
 * loading we deny (deny-by-default) — the backend enforces the real check too.
 */
export const useCanCreateStoryboard = (): boolean =>
  useSelector((state: ExperiencesWorkspaceState) => {
    const workspace = state.experiences.workspaces.workspace.item;
    if (!workspace) return false;
    if (workspace.superAdmin === true) return true;
    return (workspace.userRoles ?? []).some(
      (role) => role?.workspaceManagement?.createStoryBoards === true,
    );
  });
